// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__3vIbp","logo":"MainNavigation_logo__1wwzl","nav":"MainNavigation_nav__14WCU","active":"MainNavigation_active__2QLLl"};